import input from './editors/input.js';
import textarea from './editors/textarea.js';
import number from './editors/number.js';
import range from './editors/range.js';
import select from './editors/select.js';
import list from './editors/list.js';
import autocomplete from './editors/autocomplete.js';
import star from './editors/star.js';
import progress from './editors/progress.js';
import tickCross from './editors/tickCross.js';

export default {
	input:input,
	textarea:textarea,
    number:number,
    range:range,
	select:select,
	list:list,
	autocomplete:autocomplete,
	star:star,
	progress:progress,
	tickCross:tickCross,
};